import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/jobCodesForJobFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/jobCodesForJobFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/jobCodesForJobFilter`;
